import { useTranslation } from 'react-i18next';

import { Footer, HeroBackground, Section, SectionText, SectionTitle } from 'components';

const TermsPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeroBackground background={true}>
                <Section hero={true}>
                    <SectionTitle variant='light' title={t('terms.title')} />
                    <div style={{ whiteSpace: 'pre-line' }}>
                        <SectionText text={t('terms.content')} />
                    </div>
                </Section>
            </HeroBackground>
            <Footer />
        </>
    )
}

export default TermsPage;